import { Component } from '@angular/core';


@Component({
    selector: 'ap-logo-sm',
    styles: [
        `
        :host {
            display: inline-block;
        }
        svg {
            width: 100%;
            height: 100%;
        }
        `,
    ],
    template: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="40 20 90.9 46.8" width="90.9px" height="46.8px">
            <path d="M74.1 62.3L63.5 66.8L40 36.6L64.5 25.1L74.1 62.3Z" fill="white"/>
            <path d="M96.8 62.3L107.4 66.8L130.9 36.6L106.5 25.1L96.8 62.3Z" fill="white"/>
            <path d="M92.8 61.3H78.2L68.8 20H102.1L92.8 61.3Z" fill="white"/>
        </svg>
    `,
})
export class LogoSmComponent {}
